import { render, staticRenderFns } from "./ResultsPerPersonPage.vue?vue&type=template&id=79b33a81&scoped=true&"
import script from "./ResultsPerPersonPage.vue?vue&type=script&lang=js&"
export * from "./ResultsPerPersonPage.vue?vue&type=script&lang=js&"
import style0 from "./ResultsPerPersonPage.vue?vue&type=style&index=0&id=79b33a81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b33a81",
  null
  
)

export default component.exports